import DropdownButton from '@shared/components/DropdownButton/DropdownButton';
import { DropdownSelectionProps } from '@shared/components/DropdownButton/DropdownSelection';
import Input from '@shared/components/InputGroup/Input';
import cx from 'classnames';

import { ReactComponent as ArrowDown } from 'assets/icons/ArrowDown.svg';

interface TimeZoneDropdownProps {
  currentValue: string;
  options: DropdownSelectionProps[];
}

const TimeZoneDropdown = ({ currentValue, options }: TimeZoneDropdownProps) => (
  <DropdownButton
    className="max-h-60 h-full overflow-x-hidden overflow-y-scroll"
    options={options}
    placement="bottom-start"
    dropdownContainerClass="my-2.5 w-full !min-w-0"
    dropdownOffset={6}
  >
    {({ open }) => (
      <Input
        value={currentValue}
        variant="white-bg"
        className="truncate cursor-pointer text-gray-80"
        containerClassName={cx('!border-gray-20', { '!border-primary-50 !ring-gray-30 !ring-4': open })}
        iconClassName={cx('stroke-1 h-5 w-5 stroke-current cursor-pointer', { 'rotate-180': open })}
        icon={ArrowDown}
        autoComplete="off"
        readOnly
      />
    )}
  </DropdownButton>
);

export default TimeZoneDropdown;
